import { render } from "./JiffyServicePreview.vue?vue&type=template&id=05942dc9&scoped=true"
import script from "./JiffyServicePreview.vue?vue&type=script&lang=js"
export * from "./JiffyServicePreview.vue?vue&type=script&lang=js"

import "./JiffyServicePreview.vue?vue&type=style&index=0&id=05942dc9&scoped=true&lang=scss"

import exportComponent from "../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.7.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05942dc9"]])

export default __exports__